import modelService from '@/services/model'

export default {
  // NOTE: some times we want to pull only tickets for a specific project or board, then we can use these contextualised methods.
  // We should not need these for anything but index, since we have direct access to tickets on the API

  projectIndex: (cbOk, cbErr, projectId, pagination, backlog) => {
    return modelService.index(cbOk, cbErr, `/projects/${projectId}/tickets.json?${modelService.paginationParams(pagination)}&backlog=${backlog}`)
  },

  projectIndexUnlinked: (cbOk, cbErr, projectId, pagination) => {
    return modelService.index(cbOk, cbErr, `/projects/${projectId}/tickets.json?${modelService.paginationParams(pagination)}&unlinked=true`)
  },

  boardIndex: (cbOk, cbErr, boardId, pagination) => {
    return modelService.index(cbOk, cbErr, `/boards/${boardId}/tickets.json?${modelService.paginationParams(pagination)}`)
  },

  // split tickets hanging of another ticket
  ticketIndex: (cbOk, cbErr, ticketId) => {
    return modelService.index(cbOk, cbErr, `/ticket/${ticketId}/tickets.json`)
  },

  // split tickets hanging of a comment
  commentIndex: (cbOk, cbErr, commentId) => {
    return modelService.index(cbOk, cbErr, `/comments/${commentId}/tickets.json`)
  },

  // tickets hanging of an email
  emailIndex: (cbOk, cbErr, projectId, emailId) => {
    return modelService.index(cbOk, cbErr, `/projects/${projectId}/emails/${emailId}/tickets.json`)
  },

  // NOTE: Regular methods start here
  index: (cbOk, cbErr) => {
    return modelService.index(cbOk, cbErr, `/tickets.json`)
  },

  projectShow: (cbOk, cbErr, projectId, sequentialId) => {
    return modelService.show(cbOk, cbErr, `/projects/${projectId}/tickets/${sequentialId}.json`)
  },

  boardShow: (cbOk, cbErr, boardId, sequentialId) => {
    return modelService.show(cbOk, cbErr, `/boards/${boardId}/tickets/${sequentialId}.json`)
  },

  // should not realy use this one because it requires the actal ID and not the sequentialId
  show: (cbOk, cbErr, id) => {
    return modelService.show(cbOk, cbErr, `/tickets/${id}.json`)
  },

  projectCreate: (cbOk, cbErr, projectId, instance) => {
    return modelService.create(cbOk, cbErr, instance, `/projects/${projectId}/tickets.json`)
  },

  boardCreate: (cbOk, cbErr, boardId, instance) => {
    return modelService.create(cbOk, cbErr, instance, `/boards/${boardId}/tickets.json`)
  },

  update: (cbOk, cbErr, instance) => {
    return modelService.update(cbOk, cbErr, instance, `/tickets/${instance.id}.json`)
  }
}



// WEBPACK FOOTER //
// ./src/services/ticket.js